let PageService = function (Restangular) {
  const Service = Restangular.all("admin/custom_page");
  const ServiceImage = Restangular.all("admin/dashboard/img");

  let count = (query) => {
    return Service.customGET("count", query);
  };

  let save = (resource) => {
    if (resource.save) {
      return ServiceAPI.customPUT(copyData, resource.id);
    } else {
      return Service.post(resource);
    }
  };

  let getImg = () => {
    return ServiceImage.customGET("");
  };

  let saveImg = (data) => {
    if (data.save) {
      let _data = angular.copy(data);
      delete _data.id;
      return ServiceImage.customPUT(_data, data.id);
    } else {
      return ServiceImage.post(data);
    }
  };

  let deleteImg = (resource) => {
    return ServiceImage.customDELETE(resource.id);
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = "null";
    return Service.getList(query);
  };

  let load = (query) => {
    query.deleted_at = "null";
    return new Promise((resolve, reject) => {
      count(query)
        .then((response) => {
          let count = response[0];
          index(query)
            .then((data) => {
              resolve({ count, data });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  let show = (id) => {
    return Service.get(id);
  };

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  };

  return { index, save, show, getImg, saveImg, deleteImg };
};

PageService.$inject = ["Restangular"];

export default PageService;



// WEBPACK FOOTER //
// ./client/app/components/page/page.service.js